import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

// Convenience redirector — sends the user to their first church's slug-based
// dashboard. Pre-PR1B URL `/church-builder/dashboard?church=<id>` keeps working.
export default function ChurchBuilderDashboard() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [churches, setChurches] = useState(null);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { navigate(`/login?next=${encodeURIComponent("/church-builder/dashboard")}`); return; }
    api.get("/church-builder/my").then((r) => {
      setChurches(r.data);
      const targetId = params.get("church");
      const target = (targetId && r.data.find((c) => c.id === targetId)) || r.data[0];
      if (target) navigate(`/church-builder/${target.slug}/dashboard`, { replace: true });
    });
  }, [user, authLoading, navigate, params]);

  if (!churches) return <div className="max-w-7xl mx-auto px-6 py-20"><Loader2 className="animate-spin text-[#D4AF37]" /></div>;

  if (churches.length === 0) {
    return (
      <div data-testid="cb-dashboard-empty" className="max-w-2xl mx-auto px-6 py-24 text-center text-white">
        <div className="label-eyebrow mb-3 justify-center">No churches yet</div>
        <h1 className="font-serif-display text-4xl">Let&apos;s get you online</h1>
        <p className="text-neutral-400 mt-4">Start your 7-day free trial — no card required.</p>
        <Link to="/church-builder/register" className="btn-gold mt-8 inline-flex px-6 py-3 rounded text-xs tracking-widest uppercase font-semibold">Register a Church</Link>
      </div>
    );
  }
  return null;
}
